import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';

export const Card = styled.div`
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin: 40px 0;

  &:hover {
    box-shadow: 10px 10px 40px 0 #c9c9c9;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    display: flex;
    flex-direction: row;
    margin: 45px 0;

    height: 100%;
  }
`;

export const StyledImage = styled(Image)`
  object-fit: cover;
  object-position: center;
  flex: 0 1 180px;
  max-height: 180px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex: 0 1 50%;
    max-width: 50%;
    max-height: 100%;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

export const Content = styled.div`
  background-color: ${themeGet('colors.neutral_2')};
  padding: 35px 25px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  a {
    margin-top: auto;
    line-height: 24px;
  }

  h3 {
    font-size: 26px;
    line-height: 38px;
  }

  p {
    font-size: 18px;
    line-height: 30px;
  }

  div p {
    font-size: 12px;
    line-height: 28px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex: 0 1 50%;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 40px 90px 40px 40px;
  }

  @media only screen and (min-width: 1439px) {
    padding: 60px 110px 60px 60px;
  }
`;
